import { useState } from 'react';
import { BarChart3, Table, Settings } from 'lucide-react';
import type { WidgetConfig, ExecutionDataRow, MetricDefinition } from '@monitoring-panel/types';
import { WidgetConfigModal } from './WidgetConfigModal';

interface WidgetToolbarProps {
  availableColumns: string[];
  campaignData: ExecutionDataRow[];
  availableMetrics: MetricDefinition[];
  onAddWidget: (widget: WidgetConfig) => void;
  onOpenMetricConfig: () => void;
}

export function WidgetToolbar({ availableColumns, campaignData, availableMetrics, onAddWidget, onOpenMetricConfig }: WidgetToolbarProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [defaultType, setDefaultType] = useState<'table' | 'chart'>('table');

  const handleAddTable = () => {
    setDefaultType('table');
    setIsModalOpen(true);
  };

  const handleAddChart = () => {
    setDefaultType('chart');
    setIsModalOpen(true);
  };

  return (
    <>
      <div className="flex items-center gap-2">
        <button
          onClick={handleAddTable}
          className="adv-btn adv-btn--secondary bg-adv-card"
        >
          <Table size={16} />
          Add Table
        </button>
        <button
          onClick={handleAddChart}
          className="adv-btn adv-btn--secondary bg-adv-card"
        >
          <BarChart3 size={16} />
          Add Chart
        </button>
        <div className="w-px h-6 bg-adv-border-strong" />
        <button
          onClick={onOpenMetricConfig}
          className="adv-btn adv-btn--secondary bg-adv-card"
        >
          <Settings size={16} />
          Metric Configuration
        </button>
      </div>

      <WidgetConfigModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        availableColumns={availableColumns}
        campaignData={campaignData}
        availableMetrics={availableMetrics}
        defaultType={defaultType}
        onCreate={onAddWidget}
      />
    </>
  );
}
